import { Subscription, Subject } from 'rxjs';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PanierService } from '../../services/panier.service';
import { RightsService } from '../../services/rights.service';
import { Panier, TypePiece } from '../../models';
import { Right } from '../../models/Rights.enum';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'fs-fast-picker',
  styleUrls: ['./fast-picker.sass'],
  templateUrl: './fast-picker.component.html'
})
export class FastPickerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageName: string;
  @Input() supplierId: number;
  @Input() cartContent: Panier;
  @Output() clickPay = new EventEmitter<any>();
  @Output() cartAmountValue?: EventEmitter<number> = new EventEmitter<number>();
  @Input() cartAmount: number;
  @Input() payDisabled: boolean;
  cartAmountChange = new Subject<string>();
  cartAmountChange$ = this.cartAmountChange.asObservable();
  cartAmountChangeSubscription: Subscription;
  errorOnAmount = false;
  hasPayRight: boolean;
  hasCartRight: boolean;
  rights = Right;
  TypePiece = TypePiece;
  inputDisabled: boolean;

  constructor(
    public panierService: PanierService,
    public rightsService: RightsService,
    private toastr: ToastrService
  ) {
    this.cartAmountChangeSubscription = this.cartAmountChange$.pipe(distinctUntilChanged())
      .subscribe(amount => this.onAmountChange(amount));
  }

  ngOnInit() {
    this.hasPayRight = this.rightsService.hasReadWriteRights(Right.Payment);
    this.hasCartRight = this.rightsService.hasReadWriteRights(Right.Cart);
    this.inputDisabled = !this.hasCartRight || this.pageName === 'select-pay' || this.cartContent.DetailPanier.length !== 1;
  }

  onAmountChange(value: string): void {
    const newAmount = +value.replace(/\s+/, '').replace(',', '.');
    this.cartAmountValue.emit(newAmount);
    if (this.isNotValidAmount(newAmount)) {
      this.payDisabled = true;
      this.errorOnAmount = true;
      this.toastr.error('Le montant saisi est invalide');
    } else {
      this.payDisabled = false;
      this.errorOnAmount = false;
      this.panierService.handlePartialPayment(newAmount);
    }
  }

  private isNotValidAmount(amount: number): boolean {
    return isNaN(amount) || amount <= 0 || amount > this.panierService.getInitialCartAmount();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.inputDisabled = !this.hasCartRight || this.pageName === 'select-pay' || this.cartContent.DetailPanier.length !== 1;
  }

  ngOnDestroy() {
    this.cartAmountChangeSubscription.unsubscribe();
  }
}
